import { localISODate } from "@/utils/localDate";
import type { ShiftOrderGizi } from "@/types/orderGizi";

export const STATUS_GIZI_DEWASA = [
  "Kurus (kekurangan BB tingkat berat)",
  "Kurus (kekurangan BB tingkat ringan)",
  "Normal",
  "Gemuk (kelebihan BB tingkat ringan)",
  "Gemuk (kelebihan BB tingkat berat)"
];

export const STATUS_GIZI_ANAK = [
  "Gizi buruk",
  "Gizi kurang",
  "Gizi baik",
  "Berisiko gizi lebih",
  "Gizi lebih",
  "Obesitas"
];

export const METODE_SKRINING_GIZI = [
  "MST (Malnutrition Screening Tool)",
  "STRONGkids",
  "MUST/Skrining Gizi Lanjut",
  "NRS-2002",
  "SGA (Subjective Global Assessment)",
  "MNA-SF (Mini Nutritional Assessment)"
];

export const RUTE_PEMBERIAN_GIZI = [
  "Oral",
  "Enteral (NGT/OGT)",
  "Parenteral",
  "Kombinasi oral + enteral",
  "Kombinasi enteral + parenteral"
];

export const AMBANG_ASUPAN_ADEKUAT = 80;

export const SHIFT_ORDER_GIZI: Array<{
  value: ShiftOrderGizi;
  text: string;
  jam: string;
}> = [
  { value: "pagi", text: "Pagi", jam: "07:00–14:00" },
  { value: "siang", text: "Siang", jam: "14:00–21:00" },
  { value: "malam", text: "Malam", jam: "21:00–07:00" }
];

export function labelShiftOrderGizi(shift: string | null | undefined): string {
  const opsi = SHIFT_ORDER_GIZI.find(s => s.value === shift);
  return opsi ? opsi.text : shift || "-";
}

export function shiftSekarang(
  sekarang: Date = new Date()
): { tanggal: string; shift: ShiftOrderGizi } {
  const jam = sekarang.getHours();

  if (jam < 7) {
    const kemarin = new Date(sekarang.getTime());
    kemarin.setDate(kemarin.getDate() - 1);
    return { tanggal: localISODate(kemarin), shift: "malam" };
  }

  return {
    tanggal: localISODate(sekarang),
    shift: jam < 14 ? "pagi" : jam < 21 ? "siang" : "malam"
  };
}
